export const DOCUMENTS_REQUEST = "DOCUMENTS_REQUEST"
export const DOCUMENTS_SUCCESS = "DOCUMENTS_SUCCESS"
export const DOCUMENTS_ERROR = "DOCUMENTS_ERROR"

export const SEND_DOCUMENTS_REQUEST = "SEND_DOCUMENTS_REQUEST"
export const SEND_DOCUMENTS_ERROR = "SEND_DOCUMENTS_ERROR"
export const SEND_DOCUMENTS_SUCCESS = "SEND_DOCUMENTS_SUCCESS"
